// src/components/PlanTable/PlanTable.js
import React from "react";
import { fmtDate, tl } from "../../utils/format";

const toNum = (v) => {
  if (v === null || v === undefined || v === "") return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

const tlSafe = (v) => {
  const n = toNum(v);
  if (n === null) return "—";
  try {
    return tl(n);        // senin format fonksiyonun
  } catch {
    return String(n);    // tl çökerse ham sayı
  }
};

export default function PlanTable({ rows = [], totalBudget, currency = "TRY" }) {
  const safeRows = Array.isArray(rows) ? rows : [];

  const withTotals = safeRows.map((r, idx) => {
    const period = toNum(r?.period) ?? 1;
    const unitNumber = toNum(r?.unitNumber) ?? 0;
    const unitPrice = toNum(r?.unitPrice) ?? 0;
    const faces = toNum(r?.faces) ?? 0;
    return {
      _key: r?.id || r?._id || idx,
      address: r?.address ?? "—",
      startDate: r?.startDate || null,
      endDate: r?.endDate || null,
      period,
      unit: r?.unit ?? "—",
      unitNumber,
      faces: toNum(r?.faces) ?? 0,
      unitPrice, 
      vendor: r?.vendor ?? "—",
      _total:  (unitPrice || 0),
    };
  });

  const grandTotal =
    typeof totalBudget === "number"
      ? totalBudget
      : withTotals.reduce((s, r) => s + (Number.isFinite(r._total) ? r._total : 0), 0);

  const columns = [
    { key: "address", label: "Adres" },
    { key: "startDate", label: "Başlangıç Tarihi", cell: (v) => (v ? fmtDate(v) : "—") },
    { key: "endDate", label: "Bitiş Tarihi", cell: (v) => (v ? fmtDate(v) : "—") },
    { key: "period", label: "Periyot", right: true },
    { key: "unit", label: "Ünite" },
    
    { key: "unitNumber", label: "Ünite Sayısı", right: true },
    { key: "faces", label: "Faces", right: true },
    // ✅ burada güvenli format
    { key: "unitPrice", label: `Fiyat`, right: true, cell: (v) => tlSafe(v) },
    { key: "vendor", label: "Vendor" },
  ];

  return (
    <div className="mt-4 card p-0 overflow-hidden">
      <div className="table-wrap overflow-auto">
        <table className="min-w-[1000px] w-full text-sm">
          <thead>
            <tr className="text-slate-600">
              {columns.map((c) => (
                <th
                  key={c.key}
                  className={`cell font-semibold border-b border-slate-200 ${c.right ? "text-right" : "text-left"}`}
                >
                  {c.label}
                </th>
              ))}
            </tr>
          </thead>

          <tbody className="bg-white">
            {withTotals.map((row, idx) => (
              <tr key={row._key} className={`border-b border-slate-100 ${idx % 2 === 1 ? "bg-slate-50/40" : ""} hover:bg-slate-50`}>
                {columns.map((col) => {
                  const raw = row[col.key];
                  const content = col.cell ? col.cell(raw, row) : (raw ?? "—");
                  return (
                    <td key={col.key} className={col.right ? "cell-num" : "cell"}>
                      {content}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>

          <tfoot>
            <tr className="bg-slate-100/80">
              <td className="cell text-right font-semibold" colSpan={columns.length - 2}>
                Total Budget
              </td>
              <td className="cell-num font-semibold">{tlSafe(grandTotal)}</td>
              <td className="cell"></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}
